// src/plugins/axios.js
import axios from 'axios';
import router from '../router';
import { ElMessage, ElMessageBox } from 'element-plus'
// 创建 axios 实例
const axiosInstance = axios.create({
  baseURL: 'https://www.tuoshouwang.com', // 你的基础 URLhttps://pem.haotuoguan.com
 timeout: 1000000, // 请求超时时间
  
});
 
// 添加请求拦截器
axiosInstance.interceptors.request.use(config => {
  const token = window.localStorage.getItem('token')
    /* var url = window.location.href; 
     console.log(token);*/
    if (token) {
        config.headers.Authorization = 'Bearer ' + token
        // config.headers.env = 'dev'
    }
  
  return config;
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error);
});
 
// 添加响应拦截器
axiosInstance.interceptors.response.use(response => {
  if (response.data.code === 9) {
        localStorage.removeItem('token')
        localStorage.removeItem('user_id')
        localStorage.removeItem('lead_id')
        localStorage.removeItem('username')
        localStorage.removeItem('mobile')
        router.push('/login')
    }
  // 对响应数据做点什么
  return response;
}, error => {
  // 对响应错误做点什么
  return Promise.reject(error);
});

export default axiosInstance;